import { render, staticRenderFns } from "./SettingsMail.vue?vue&type=template&id=f8c6514c&scoped=true"
import script from "./SettingsMail.vue?vue&type=script&lang=js"
export * from "./SettingsMail.vue?vue&type=script&lang=js"
import style0 from "./SettingsMail.vue?vue&type=style&index=0&id=f8c6514c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c6514c",
  null
  
)

export default component.exports